import React, { useState, useEffect } from 'react';
import { css, cx } from 'emotion';
import { useHistory } from 'react-router-dom';
import { CustomButton } from '../components/CustomButton';
import { ButtonContainer } from '../components/ButtonContainer';
import InfoIcon from '../../assets/infoIcon.svg?react';
import { Header } from '../components/Header';
import { Footer } from '../components/Footer';
import { salesforceStore } from '../../store/salesforce-store';
import infoIconBlack from "../../assets/infoIconBlack.svg";

const pageContainer = css`
  display: flex;
  flex-direction: column;
  margin: 0 auto;
  width: 60%;
  align-items: center;
  height: calc(100vh - 5rem);
  padding: 2rem;

  @media (max-width: 768px) {
    min-height: calc(100vh - 5rem);
    padding: 1rem 2rem;
    width: 100%;
  }
`;

const contentContainer = css`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
  flex-grow: 1;
`;

const imgStyle = css`
  width: 8rem;
  height: 8rem;

  @media (max-width: 768px) {
    width: 6rem;
    height: 6rem;
  }
`;

const titleStyle = css`
  font-family: Lato, sans-serif;
  margin: 3.5rem 0 1.5rem;
  font-weight: bold;
  font-size: 1.5rem;
  line-height: 1.25;
  letter-spacing: -0.03em;
  color: var(--dark);
`;

const textStyle = css`
  font-family: Lato, sans-serif;
  margin-bottom: 1rem;
  line-height: 1.5;
  font-size: 1rem;
  color: var(--dark);
`;

const linkStyle = css`
  color: var(--primaryBrand);
  font-weight: bold;
`;

const bottomContainerStyle = css`
  width: fit-content;
  margin-inline: auto;

  @media (max-width: 768px) {
    width: 100%;
  }
`;

const ReferralScreen = () => {
  const history = useHistory();
  const [theme, setTheme] = useState('light');

  useEffect(() => {
    const rootElement = document.documentElement;

    const checkTheme = () => {
      const currentTheme = rootElement.getAttribute('data-theme');
      setTheme(currentTheme || 'light');
    };

    checkTheme();

    const observer = new MutationObserver(checkTheme);
    observer.observe(rootElement, { attributes: true, attributeFilter: ['data-theme'] });

    return () => observer.disconnect();
  }, []);
  return (
    <div className="App">
      <Header />
      <main className={pageContainer}>
        <div className={contentContainer}>
          {theme === 'dark' ? (
            <img src={infoIconBlack} className={cx(imgStyle, 'keep-color')} alt="Error" />
          ) : (
            <InfoIcon className={imgStyle} />
          )}
          <h1 className={titleStyle}>Thank you for using Insync for your business insurance quotation.</h1>
          <p className={textStyle}>
            Your quote has gone into referral, to offer you the best quote based on your level of expertise we will
            contact you to obtain further information. If you do have any questions, please contact us on{' '}
            <a href="tel:0330 124 0730" className={linkStyle}>
              0330 124 0730
            </a>{' '}
            or email us at{' '}
            <a href="mailto:hello@insyncinsurance.co.uk" className={linkStyle}>
              hello@insyncinsurance.co.uk
            </a>
            .
          </p>
        </div>
        <ButtonContainer customAlignment={bottomContainerStyle}>
          <CustomButton
            fullWidth
            handleClick={() => {
              history.replace(
                salesforceStore.salesforceOpportunityId
                  ? `/opportunity/${salesforceStore.salesforceOpportunityId}`
                  : '/'
              );
              history.go(0);
            }}
            label="BACK TO HOME"
          />
        </ButtonContainer>
      </main>
      <Footer />
    </div>
  );
};

export default ReferralScreen;
